import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import { FieldError } from "react-hook-form";

type CheckboxProps = {
  label?: string;
  description?: string;
  error?: FieldError;
  htmlFor?: string;
} & Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  "type"
>;

// MIGRATE: WOMBAT UI
const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, description, error = {}, htmlFor, ...props }, ref) => {
    if (label)
      return (
        <div className="relative flex items-start">
          <div className="flex items-center h-5">
            <input
              {...props}
              ref={ref}
              type="checkbox"
              className="w-4 h-4 text-primary-600 transition duration-150 ease-in-out form-checkbox"
            />
          </div>
          <div className="ml-3 text-sm leading-5">
            <label htmlFor={htmlFor} className="font-medium text-gray-700">
              {label}
            </label>
            {description && <p className="text-gray-500">{description}</p>}
            {error?.message && <p className="text-red-600">{error.message}</p>}
          </div>
        </div>
      );

    return (
      <input
        {...props}
        ref={ref}
        type="checkbox"
        className="w-4 h-4 text-primary-600 transition duration-150 ease-in-out form-checkbox"
      />
    );
  }
);

Checkbox.displayName = "Checkbox";

export default React.memo(Checkbox);
